import { createSlice } from "@reduxjs/toolkit";
export const summarySlice = createSlice({
  name: "summarySlice",
  initialState: {
    data: {
      Farmer: null,
      Farm: null,
      Crop: null,
      Land: null,
      insightMessage: null,
      hideWelomeMessage: false,
      loading: {
        Farmer: false,
        Farm: false,
        Crop: false,
        Land: false,
        insightMessage: null,
      },
    },
  },
  reducers: {
    createSummaryRecordFarm: (state, action) => {
      state.data.Farm = action.payload.farm;
    },
    createSummaryRecordFarmer: (state, action) => {
      state.data.Farmer = action.payload.farmer;
    },
    createSummaryRecordCrop: (state, action) => {
      state.data.Crop = action.payload.crop;
    },
    createSummaryRecordArea: (state, action) => {
      state.data.Land = action.payload.land;
    },
    createLoadingStateFarm: (state, action) => {
      state.data.loading.Farmer = action.payload.data;
    },
    createLoadingStateFarmer: (state, action) => {
      state.data.loading.Farm = action.payload.data;
    },
    createLoadingStateCrop: (state, action) => {
      state.data.loading.Crop = action.payload.data;
    },
    createLoadingStateArea: (state, action) => {
      state.data.loading.Land = action.payload.data;
    },
    createSummaryMessageRecord: (state, action) => {
      state.data.insightMessage = action.payload.data;
    },
    createHiddenMessageRecord: (state, action) => {
      state.data.hideWelomeMessage = action.payload.data;
    },
  },
});

export const {
  createSummaryRecordFarm,
  createSummaryRecordFarmer,
  createSummaryRecordCrop,
  createSummaryRecordArea,
  createLoadingStateFarm,
  createLoadingStateFarmer,
  createLoadingStateCrop,
  createLoadingStateArea,
  createSummaryMessageRecord,
  createHiddenMessageRecord,
} = summarySlice.actions;
export default summarySlice.reducer;
